module.exports = __webpack_public_path__ + "static/img/rocket.df6c224.gif";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/rocket.gif
// module id = 955
// module chunks = 30